export const ActionTypes = {
  SET_MEMBERSHIPS_ACCOUNT_LIST: 'SET_MEMBERSHIPS_ACCOUNT_LIST'
};
